export default function genererParametrageEdition() {
  return {
    typeEdition: null,
    afficherLogo: true,
    afficherPiedPage: true,
    margeHaut: null,
    margeBas: null,
    margeGauche: null,
    margeDroite: null,
    societeId: null,
  };
}
